import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    Email: yup.string().email('Укажите верную почту').required('Обязательное поле'),
    OneTimePassword: yup.string().length(6, 'Длина должна быть 6 символов').required('Обязательное поле'),
});

export const emailValidationSchema = yup.object().shape({
    Email: yup.string().email('Укажите верную почту').required('Обязательное поле'),
});